
(function () {
    "use strict";
  
    function function_image_hover_plp() {
      const style = document.createElement("style");
      style.textContent = `
      
      `;
      document.head.append(style);
      // Start loading each card's 2nd photo a little before it scrolls into
      // view, so the first hover doesn't flash an empty card.
      const preloadObserver = "IntersectionObserver" in window
        ? new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              preloadObserver.unobserve(entry.target);
              let second = entry.target.querySelectorAll(".product-secondary-image")[1];
              if (second && second.loading === "lazy") second.loading = "eager";
            });
          }, { rootMargin: "100% 0px" })
        : null;

      function initCard(container) {
        // Each card is set up once; "Load more" cards are set up when added.
        if (container.dataset.hoverInit) return;
        container.dataset.hoverInit = "true";
        if (preloadObserver) preloadObserver.observe(container);

        let images = Array.from(container.querySelectorAll(".product-secondary-image"));
        let currentImageIndex = 0;
        let lastClickedIndex = 0;
        let isHovering = false;
        let wantedIndex = 0;

        function showImage(index) {
            wantedIndex = index;
            let target = images[index];
            // Keep the current photo until the next one has downloaded.
            if (target && !(target.complete && target.naturalWidth)) {
                target.loading = "eager";
                target.addEventListener("load", function () {
                    if (wantedIndex === index) showImage(index);
                }, { once: true });
                return;
            }
            images.forEach((img, i) => {
            
                img.style.display = i === index ? "block" : "none";
            });
        }

        // Hover effect
        container.addEventListener("mouseenter", function () {
            isHovering = true;
            let nextIndex = currentImageIndex + 1 < images.length ? currentImageIndex + 1 : currentImageIndex;
            showImage(nextIndex);
        });

        container.addEventListener("mouseleave", function () {
            isHovering = false;
            showImage(lastClickedIndex);
        });

        // Handle next image click
        let nextButton = container.querySelector(".right-arrow");
        if (nextButton) {
            nextButton.addEventListener("click", function (event) {
                event.stopPropagation(); // Prevent interfering with hover events
                if (currentImageIndex + 1 < images.length) {
                    currentImageIndex++;
                }
                lastClickedIndex = currentImageIndex;
                showImage(currentImageIndex);

                if (isHovering) {
                    let hoverIndex = currentImageIndex + 1 < images.length ? currentImageIndex + 1 : currentImageIndex;
                    showImage(hoverIndex);
                }
            });
        }

        // Handle previous image click
        let prevButton = container.querySelector(".left-arrow");
        if (prevButton) {
            prevButton.addEventListener("click", function (event) {
                event.stopPropagation();
                if (currentImageIndex > 0) {
                    currentImageIndex--;
                }
                lastClickedIndex = currentImageIndex;
                showImage(currentImageIndex);

                if (isHovering) {
                    let hoverIndex = currentImageIndex + 1 < images.length ? currentImageIndex + 1 : currentImageIndex;
                    showImage(hoverIndex);
                }
            });
        }

        // Handle swatches
        let swatches = Array.from(container.closest(".product-card").querySelectorAll(".product-card-swatch"));
        swatches.forEach((swatch) => {
            swatch.addEventListener("click", function (event) {
                event.stopPropagation();

                let variantId = swatch.getAttribute("data-variant-id");

                if (variantId) {
                    let matchingImageIndex = images.findIndex(img => {
                        let variantIds = img.getAttribute("data-variant-ids");
                        return variantIds && variantIds.includes(variantId);
                    });

                    if (matchingImageIndex !== -1) {
                        currentImageIndex = matchingImageIndex;
                        lastClickedIndex = matchingImageIndex;
                        showImage(matchingImageIndex);
                    }
                }
            });
        });
      }

      document.querySelectorAll(".product-featured-image").forEach(initCard);

      // Products added later by "Load more" or filters.
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches(".product-featured-image")) initCard(node);
            else node.querySelectorAll(".product-featured-image").forEach(initCard);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }

    function onDOMContentLoaded() {
        const path = location.pathname;
        const isHomePage = path == "/";
        const isProducts = path.includes("/products");
        const isCollections = path.includes("/collections") && !isProducts;
        const isSearchPage = path.includes("/search");
        const isCart = path == "/cart";
        if(isCollections || isHomePage || isSearchPage){
            function_image_hover_plp();
        }
      }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
        once: true,
      });
    } else {
      onDOMContentLoaded();
    }
  })();